import { useState } from 'react';

import Slider from 'react-slick';

import SliderCard from '../../atoms/slider-card/sliderCard';
import './infoSlider.scss';

const InfoSlider = (props: any) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };

  const isActiveNext = (_true: any, _false: any) => {
    return sliderIndex < props.referenciaPlantillaContenido.referencias.length - 4 ? _true : _false;
  };

  const isActiveBack = (_true: any, _false: any) => (sliderIndex > 0 ? _true : _false);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerMode: false,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          dots: true,
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 330,
        settings: {
          dots: true,
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="m-infoSlider">
      <div className="m-infoSlider-header">
        <h2>{props.referenciaPlantillaContenido.titulo}</h2>
        <p>{props.referenciaPlantillaContenido.subtitulo}</p>
      </div>
      <div className="hide-on-mobile">
        <Slider ref={(_slider) => setSlider(_slider)} {...settings}>
          {props.referenciaPlantillaContenido.referencias.map((coverPage, index) => (
            <SliderCard key={`sliderCard${index}`} coverpage={coverPage} />
          ))}
        </Slider>
        <div
          className="arrow-content arrow-content__left"
          onClick={isActiveBack(goToBack, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveBack(
                  'arrow icon-chevron-left active',
                  'arrow icon-chevron-left',
                )}
              />
            </div>
          </div>
        </div>
        <div
          className="arrow-content arrow-content__right"
          onClick={isActiveNext(goToNext, undefined)}
        >
          <div className="arrows">
            <div className="arrows-contain">
              <div
                className={isActiveNext(
                  'arrow icon-chevron-right active',
                  'arrow icon-chevron-right',
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="show-on-mobile">
        <Slider {...settings}>
          {props.referenciaPlantillaContenido.referencias.map((coverPage, index) => (
            <SliderCard key={`covepage${index}`} coverpage={coverPage} />
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default InfoSlider;
